import React, { useState, useEffect } from 'react';
import CertifiedTutors from '../components/CertifiedTutors';
import Testimonials from '../components/Testimonials';
import './QuranReadingClasses.css';
import '../components/AboutFeatures.css';
import '../components/FAQSection.css';
import ConsultationSection from '../components/ConsultationSection';

const QuranReadingClasses = () => {
  const [rotation, setRotation] = useState(0);
  const [faqOpenStates, setFaqOpenStates] = useState({ 'rc-left-0': true });

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setRotation(scrollY * 0.15);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);



  return (
    <div className="recitation-course-page">
      {/* 1. Hero Section */}
      <section
        className="about-hero"
        style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/home-banner.jpg')` }}
      >
        <div className="about-hero__content">
          <h1 className="about-hero__title">Online Quran Recitation Course</h1>
          <nav className="about-hero__breadcrumb" aria-label="breadcrumb">
            <a href="/" className="about-hero__breadcrumb-link">
              Home
            </a>
            <span className="about-hero__breadcrumb-separator">&gt;</span>
            <span className="about-hero__breadcrumb-current">Quran Recitation</span>
          </nav>
        </div>
      </section>

      {/* 2. Intro Content Section */}
      <section className="recitation-intro-section">
        <div className="recitation-container">
          <h2 className="recitation-main-heading">Quran Recitation Course Online for Kids and Adults</h2>
          <div className="recitation-heading-underline"></div>
          <p className="recitation-intro-desc">
            Start your Quran journey the right way. Al Quran Lesson offers a structured, one-on-one online Quran recitation course, taught by certified native Arabic tutors, available 24/7 across all USA time zones. Whether you are a complete beginner, a parent enrolling your child, or an adult reconnecting with the Quran, our Quran recitation classes online are designed to help you read with proper pronunciation, confident rhythm, and correct Tajweed rules from day one.
          </p>
          <div className="recitation-cta-wrapper">
            <a href="/free-trial/" className="btn-green-cta-large">
              Start Your 3-Day Free Trial – No Payment Required
            </a>
          </div>
        </div>
      </section>



      {/* 3. Why Designed Section (Adapted from Who We Are) */}
      <section
        className="recitation-about"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/hero-bottom.webp')`
        }}
      >
        <div className="recitation-about__container">
          {/* Left Column: Overlapping Images */}
          <div className="recitation-about__images-wrapper">
            {/* Rotating Stamp */}
            <div
              className="recitation-about__stamp"
              style={{ transform: `rotate(${rotation}deg)` }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/G-3.webp`}
                alt="Certified Quran Academy Stamp"
                className="recitation-about__stamp-img"
              />
            </div>

            {/* Top Image */}
            <div className="recitation-about__img-container recitation-about__img-container--top">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/BG-3.jpg`}
                alt="Online Quran Classes For Kids"
                className="recitation-about__main-img"
              />
            </div>

            {/* Bottom Image */}
            <div className="recitation-about__img-container recitation-about__img-container--bottom">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/wmremove-transformed-2.jpeg`}
                alt="Online Quran Classes For Kids"
                className="recitation-about__main-img"
              />
            </div>
          </div>

          {/* Right Column: Text & Content */}
          <div className="recitation-about__content">
            <h2 className="recitation-about__title">
              Why We Have Designed Online Quran Recitation Course?
            </h2>

            <p className="recitation-about__paragraph">
              Our Online Quran recitation classes are live, one-on-one virtual sessions where our <a href="/our-tutors/" className="green-link">certified Quran tutor</a> guides you step by step through the correct pronunciation, rhythm, and rules of reading the Holy Quran. Instead of traveling to a local masjid or Islamic center, you connect with your teacher through a secure video platform from anywhere in the world, at a time that fits your daily routine.
            </p>

            <p className="recitation-about__paragraph">
              Our online Quran recitation course covers everything from recognizing Arabic letters and forming words to reciting complete Surahs with proper Tajweed application. Students receive real-time correction, consistent feedback, and a completion certificate when they finish their course.
            </p>

            <p className="recitation-about__paragraph underline-highlight">
              Check out our <a href="/online-tajweed-classes-tajweed-course/" className="green-link">online Tajweed course</a> to learn the Quran with complete Tajweed rules.
            </p>

            <ul className="recitation-about__list">
              <li className="recitation-about__list-item">
                <span className="recitation-about__list-bullet"></span>
                Certified Native Arabic Tutors
              </li>
              <li className="recitation-about__list-item">
                <span className="recitation-about__list-bullet"></span>
                24/7 Availability, All US Time Zones
              </li>
              <li className="recitation-about__list-item">
                <span className="recitation-about__list-bullet"></span>
                Completion Certificate for Every Course
              </li>
            </ul>

            <div className="recitation-about__contacts">
              <a href="tel:+17164577657" className="recitation-about__contact-item">
                <div className="recitation-about__contact-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="recitation-about__contact-svg">
                    <path d="M6.62 10.79a15.15 15.15 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.27 11.72 11.72 0 003.7.59 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.72 11.72 0 00.59 3.7 1 1 0 01-.27 1.11z" />
                  </svg>
                </div>
                <div className="recitation-about__contact-text">
                  <span className="recitation-about__contact-label">Call Us Anytime</span>
                  <span className="recitation-about__contact-value">(716) 457-7657</span>
                </div>
              </a>

              <a href="mailto:info@alquranlesson.com" className="recitation-about__contact-item">
                <div className="recitation-about__contact-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="recitation-about__contact-svg">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                  </svg>
                </div>
                <div className="recitation-about__contact-text">
                  <span className="recitation-about__contact-label">Email Us Anytime</span>
                  <span className="recitation-about__contact-value">info@alquranlesson.com</span>
                </div>
              </a>
            </div>

            <a href="/free-trial/" className="recitation-about__btn">
              Book Your 3-Day Free Trial
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="recitation-about__btn-icon">
                <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z" />
              </svg>
            </a>
          </div>
        </div>
      </section>





      {/* 4. Steps Section */}
      <section className="recitation-steps-section">
        <div className="recitation-container steps-grid">
          <div className="step-card">
            <h3>Arabic Alphabets</h3>
            <p>Students are taught basic Arabic letters in the Arabic Accent.</p>
          </div>
          <div className="step-card">
            <h3>Alphabet Pronunciation</h3>
            <p>Students are taught the real Arabic pronunciation of letters along with the rules of Tajweed.</p>
          </div>
          <div className="step-card">
            <h3>Reciting Quran</h3>
            <p>After finishing the beginner book, Juzz by Juzz reading Quran.</p>
          </div>
        </div>
      </section>



      {/* 5. Who Can Join Section */}
      <section className="recitation-who-can-join">
        <div className="recitation-container">
          <div className="section-header-center">
            <h2>Who Can Join Our Online Quran Recitation Course?</h2>
          </div>
          <div className="recitation-who-can-join-layout two-col-layout">
            <div className="join-left-cards">
              <div className="join-card">
                <h3>Quran Recitation Classes for Kids</h3>
                <p>
                  Children as young as 4 years old can begin with our structured beginner program. We start from the Arabic alphabet using the <a href="/noorani-qaida-course/" className="green-link">Noorani Qaida course</a>. Short, engaging lessons with repetition, visual cues, and consistent encouragement. Our teachers are experienced in working with young learners and know how to keep children focused while building a genuine love for the Quran.
                </p>
              </div>
              <div className="join-card">
                <h3>Quran Recitation Classes for Adults</h3>
                <p>
                  Adults who never had the opportunity to learn, or who want to correct years of improper recitation, will find a respectful, patient, and structured learning environment here. There is no age limit and no pressure. Many of our adult students come in as complete beginners and progress to fluent Quran reading within a few months of consistent sessions.
                </p>
              </div>
              <div className="join-card">
                <h3>Quran Classes for Sisters (Female Students)</h3>
                <p>
                  We offer dedicated female Quran tutors, qualified Qarias and ijazah holders who work exclusively with female students and children. Sisters can enroll with full confidence in a comfortable, modest learning environment.
                </p>
              </div>
            </div>
            <div className="join-right-image">
              <img src={`${process.env.PUBLIC_URL}/assets/images/course1/Img-11.jpg`} alt="Online Quran Tajweed Course - Al Quran Lesson" />
            </div>
          </div>
        </div>
      </section>

      {/* 6. Objective Section */}
      <section className="recitation-objective">
        <div className="recitation-container">
          <div className="recitation-objective-layout two-col-layout">
            <div className="objective-left-content">
              <h2>Objective Of Our Online Quran Recitation Course</h2>
              <p>
                Welcome to our online Quran reading course! Designed for those seeking a deeper understanding of Quran recitation. Whether you have no prior knowledge of Arabic or just the basics, our online Quran recitation course is perfect for you. Our experienced instructors will guide you through the fundamentals of Quran reading, helping you to develop your skills and knowledge of this holy text. By the end of the course, you'll have a solid understanding of reading the Quran and the ability to read it with confidence. <a href="/free-trial/" className="green-link">Enroll now</a> and take your first step towards a deeper understanding of Islam and the Quran!
              </p>
            </div>
            <div className="objective-right-image">
              <img src={`${process.env.PUBLIC_URL}/assets/images/quran-reading.webp`} alt="Quran Recitation Objective" />
            </div>
          </div>
        </div>
      </section>



      {/* 6. Tutors Section */}
      <CertifiedTutors />
      {/* 7. Testimonials Section */}
      <Testimonials />

      {/* 8. Beginner Friendly Section */}
      <section className="recitation-beginner-friendly">
        <div className="recitation-container">
          <div className="recitation-beginner-friendly-layout two-col-layout">
            <div className="beginner-friendly-left">
              <h2>Beginner Friendly Quran Recitation Classes Online</h2>
              <p>
                Our online Quran recitation classes are designed for beginners who want to develop the necessary skills to read the Quran fluently. You'll learn letter recognition and correct pronunciation through a comprehensive overview of the Arabic alphabet. This course is suitable for novices and individuals with prior experience in the language, guiding you to help you achieve your goals.
              </p>
              <p>
                Our experienced teachers are dedicated to providing the <a href="/" className="green-link">best online Quran classes</a>. We will guide you through the course to gain fluency in reading Quran verses with proper pronunciation, intonation, and rhythm. With more than 13 years of experience, our highly qualified teachers will help you understand the Quran and develop basic reading skills from right to left.
              </p>
              <a href="/free-trial/" className="btn-green-cta">Get 3 Days Free Trail Now</a>
            </div>
            <div className="beginner-friendly-right">
              <div className="vector-image-box">
                <img src={`${process.env.PUBLIC_URL}/assets/images/qari-vector.png`} alt="Beginner Friendly Quran Recitation" />
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* 4.5. Key Features Section */}
      <section className="recitation-key-features">
        <div className="recitation-container">
          <div className="section-header-center">
            <h2>Key Features Of Our Online Quran Recitation Course</h2>
          </div>

          <div className="key-features-grid">
            <div className="feature-card">
              <h3>Arabic Alphabet Recognition</h3>
              <p>Our Quran reading course online starts by teaching you the Arabic alphabet, including letter recognition and proper pronunciation.</p>
            </div>

            <div className="feature-card">
              <h3>Proficiency In Reading Quran Verses:</h3>
              <p>Our Quran reading classes online is designed to help you gain proficiency in reading Quran verses, including intonation, rhythm.</p>
            </div>

            <div className="feature-card">
              <h3>Basic Reading Skills Development</h3>
              <p>Our Quran reading classes online helps you develop the basic reading skills necessary for reading the Quran with ease.</p>
            </div>

            <div className="feature-card">
              <h3>Practice And Feedback</h3>
              <p>Our course is carefully structured to provide you with ample practice and feedback, ensuring that you have the opportunity to reinforce your learning and progress at a comfortable pace.</p>
            </div>

            <div className="feature-card">
              <h3>Flexible Scheduling & Personalized Teaching</h3>
              <p>We offer flexible online Quran reading schedules to accommodate busy students and believe in personalized attention. Our one-on-one sessions ensure individualized attention, tailored to each student's needs.</p>
            </div>
          </div>

          <div className="features-cta-wrapper">
            <a href="/free-trial/" className="btn-green-cta-center">Book Your 3 Days Free Trial</a>
          </div>
        </div>
      </section>

      {/* 2.5. Benefits Intro Section */}
      <section
        className="recitation-benefits-intro"
        style={{ '--benefits-bg': `url('${process.env.PUBLIC_URL}/assets/images/green-bg.png')` }}
      >
        <div className="recitation-container">
          <div className="benefits-intro__badge">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" className="benefits-badge-icon">
              <path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z" />
            </svg>
            <span>Benefits</span>
          </div>
          <h2 className="benefits-intro__title">
            Why Choose Al Quran Lessons' Online Quran Recitation Course?
          </h2>
          <p className="benefits-intro__desc">
            At Al Quran Lesson, we combine authentic Islamic scholarship with the flexibility of modern online learning to deliver a Quran recitation experience that is structured, personal, and results-driven. Every student, whether a child taking their first steps or an adult refining their recitation, will receive dedicated attention from a certified tutor who genuinely invests in their progress. Here is what makes our online Quran recitation course stand apart.
          </p>
        </div>
      </section>

      {/* 2.6. Benefits Features Grid Section */}
      <section className="about-features" id="recitation-benefits-features">
        <div className="about-features__container">
          <div className="about-features__grid">
            {/* Left Column: Features 1-3 */}
            <div className="about-features__col about-features__col--left">
              {/* Feature 01 */}
              <div className="about-features__item about-features__item--left">
                <div className="about-features__text">
                  <h3 className="about-features__item-title">3-Day Free Trial</h3>
                  <p className="about-features__item-desc">
                    Try our Quran recitation classes completely free for 3 days, no payment, no credit card, no commitment. Just real live sessions with a certified tutor before you decide.
                  </p>
                </div>
                <div className="about-features__badge">01</div>
              </div>

              {/* Feature 02 */}
              <div className="about-features__item about-features__item--left">
                <div className="about-features__text">
                  <h3 className="about-features__item-title">Personalized Sessions</h3>
                  <p className="about-features__item-desc">
                    Your Pace, Your Plan. Your tutor builds a custom learning roadmap based on your current level and goals, ensuring every lesson moves you forward without rushing or falling behind.
                  </p>
                </div>
                <div className="about-features__badge">02</div>
              </div>

              {/* Feature 03 */}
              <div className="about-features__item about-features__item--left">
                <div className="about-features__text">
                  <h3 className="about-features__item-title">Separate Quran Recitation Classes for Sisters</h3>
                  <p className="about-features__item-desc">
                    Female students are taught exclusively by our certified female Qarias in a private, comfortable, and fully modest learning environment, no exceptions.
                  </p>
                </div>
                <div className="about-features__badge">03</div>
              </div>
            </div>

            {/* Middle Column: Dome/Arch Capsule Image */}
            <div className="about-features__image-col">
              <div className="about-features__image-wrapper">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/About.avif`}
                  alt="Man praying inside mosque archway"
                  className="about-features__img"
                />
              </div>
            </div>

            {/* Right Column: Features 4-6 */}
            <div className="about-features__col about-features__col--right">
              {/* Feature 04 */}
              <div className="about-features__item about-features__item--right">
                <div className="about-features__badge">04</div>
                <div className="about-features__text">
                  <h3 className="about-features__item-title">Live One-on-One Classes</h3>
                  <p className="about-features__item-desc">
                    Every session is a live, interactive class with your dedicated tutor, not a pre-recorded video, so your pronunciation gets corrected in real time, every lesson.
                  </p>
                </div>
              </div>

              {/* Feature 05 */}
              <div className="about-features__item about-features__item--right">
                <div className="about-features__badge">05</div>
                <div className="about-features__text">
                  <h3 className="about-features__item-title">Hafiz & Ijazah-Certified Teachers</h3>
                  <p className="about-features__item-desc">
                    Our tutors are Huffaz and Ijazah holders, meaning they carry an unbroken chain of Quranic authority, so you learn recitation the way it has always been authentically transmitted.
                  </p>
                </div>
              </div>

              {/* Feature 06 */}
              <div className="about-features__item about-features__item--right">
                <div className="about-features__badge">06</div>
                <div className="about-features__text">
                  <h3 className="about-features__item-title">Flexible Scheduling</h3>
                  <p className="about-features__item-desc">
                    Choose any days and times that fit your routine, morning, evening, or weekend with full availability across all USA time zones around the clock.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section" id="recitation-faq">
        <div className="faq-section__container">
          <div className="faq-section__grid">
            {/* Left Column */}
            <div className="faq-section__col faq-section__col--left">
              <h2 className="faq-section__title">
                FAQs About Al Quran Lessons' Online Quran Recitation Course!
              </h2>

              <div className="faq-section__accordion">
                {[
                  {
                    id: 'rc-left-0',
                    question: "Can my child start Quran recitation classes without knowing any Arabic?",
                    answer: (<>
                      Yes, absolutely. We start from the very basics, Arabic letter recognition using the <a style={{ color: "#006100" }} href="/noorani-qaida-course/">Noorani Qaida Course</a>, so no prior Arabic or Quranic knowledge is needed. Your child can begin from zero and progress to fluent Quran recitation step by step.
                    </>)
                  },
                  {
                    id: 'rc-left-1',
                    question: "What age should my child be to start online Quran recitation classes?",
                    answer: "Children as young as 4 years old can join our beginner program. For adults, there is no age limit at all; many of our US-based adult students are learning Quran recitation for the first time in their 30s, 40s, 50s, and beyond."
                  },
                  {
                    id: 'rc-left-2',
                    question: "Are your Quran recitation classes available in my US time zone?",
                    answer: "Yes. We are available 24/7 and fully cover all US time zones, Eastern, Central, Mountain, and Pacific. Whether you prefer early morning before work, after school, or late evening, we schedule around your routine."
                  }
                ].map((faq) => (
                  <div key={faq.id} className={`faq-item ${faqOpenStates[faq.id] ? 'faq-item--open' : ''}`}>
                    <button
                      className="faq-item__header"
                      onClick={() => setFaqOpenStates({ [faq.id]: !faqOpenStates[faq.id] })}
                      aria-expanded={faqOpenStates[faq.id]}
                    >
                      <span>{faq.question}</span>
                      <svg className="faq-item__icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                      </svg>
                    </button>
                    <div className="faq-item__body">
                      <div className="faq-item__content">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Column */}
            <div className="faq-section__col faq-section__col--right">
              <div className="faq-section__accordion">
                {[
                  {
                    id: 'rc-right-0',
                    question: "Is there a free trial before I commit to a paid plan?",
                    answer: "Yes. Every new student gets a 3-day free trial, three complete live sessions at no cost, and with no credit card required. This lets you experience our teaching quality firsthand before making any decision."
                  },
                  {
                    id: 'rc-right-1',
                    question: "How many classes per week does my child need to make real progress?",
                    answer: "We recommend at least 3 sessions per week for steady, noticeable progress. Students who attend 5 sessions per week typically advance much faster. You choose the frequency that works best for your family’s schedule."
                  },
                  {
                    id: 'rc-right-2',
                    question: "Are the classes live or are they pre-recorded videos?",
                    answer: "All our classes are 100% live, one-on-one video sessions with a dedicated tutor, never pre-recorded. Live interaction is essential for correcting pronunciation mistakes in real time, which no video course can do."
                  },
                  {
                    id: 'rc-right-3',
                    question: "Do you have female Quran teachers for my daughter or wife?",
                    answer: "Yes. We have certified female Qarias who teach exclusively female students. Sisters and girls are always assigned to our qualified female tutors in a fully private and comfortable learning environment."
                  },
                  {
                    id: 'rc-right-4',
                    question: "What technology do I need to join online Quran classes?",
                    answer: "We primarily conduct classes over Zoom and Skype, platforms that most US families already use and are comfortable with. If you have a different preference, just let us know during enrollment and we will accommodate."
                  },
                  {
                    id: 'rc-right-5',
                    question: "Do you provide a certificate after completing the Quran recitation course?",
                    answer: "Yes. Every student who completes their Quran reading course receives an official completion certificate from Al Quran Lesson, a meaningful recognition of their dedication and achievement."
                  }
                ].map((faq) => (
                  <div key={faq.id} className={`faq-item ${faqOpenStates[faq.id] ? 'faq-item--open' : ''}`}>
                    <button
                      className="faq-item__header"
                      onClick={() => setFaqOpenStates({ [faq.id]: !faqOpenStates[faq.id] })}
                      aria-expanded={faqOpenStates[faq.id]}
                    >
                      <span>{faq.question}</span>
                      <svg className="faq-item__icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                      </svg>
                    </button>
                    <div className="faq-item__body">
                      <div className="faq-item__content">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <ConsultationSection />

    </div>
  );
};

export default QuranReadingClasses;

